import { render } from "./LoginBtn.vue?vue&type=template&id=4a519335&scoped=true&ts=true"
import script from "./LoginBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginBtn.vue?vue&type=script&setup=true&lang=ts"

import "./LoginBtn.vue?vue&type=style&index=0&id=4a519335&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a519335"],['__file',"src/components/header/LoginBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a519335"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a519335', __exports__)) {
    api.reload('4a519335', __exports__)
  }
  
  module.hot.accept("./LoginBtn.vue?vue&type=template&id=4a519335&scoped=true&ts=true", () => {
    api.rerender('4a519335', render)
  })

}


export default __exports__